import useShouldShowPrompt, { MobileOSInstallPromptEnum } from './pwaBannerShowPrompt.hook';
import { useEffect, useState } from 'react';

const isIOS = (): boolean => {
  // @ts-ignore
  if (navigator.standalone) {
    // user has already installed the app
    return false;
  }
  const ua = window.navigator.userAgent;
  const isIPad = !!ua.match(/iPad/i);
  const isIPhone = !!ua.match(/iPhone/i);
  return isIPad || isIPhone;
};

const useIosInstallPrompt = (): [boolean, () => void] => {
  const [userShouldBePromptedToInstall, handleUserSeeingInstallPrompt] = useShouldShowPrompt(
    MobileOSInstallPromptEnum.IOS
  );

  return [isIOS() && userShouldBePromptedToInstall, handleUserSeeingInstallPrompt];
};

export default useIosInstallPrompt;

export type OS = 'ios' | 'android' | 'desktop';
export function useDetectOS(): OS {
  const [os, setOs] = useState<OS>('desktop');

  useEffect(() => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return;
    }

    const ua = window.navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(ua)) {
      // @ts-ignore
      const isStandalone = navigator.standalone === true;
      setOs(isStandalone ? 'desktop' : 'ios');
    } else if (/android/.test(ua)) {
      setOs('android');
    } else {
      setOs('desktop');
    }
  }, []);

  return os;
}
